import type { OctopusFeatureConfiguration } from "@octopusdeploy/openfeature";
import { OctopusFeatureProvider } from "@octopusdeploy/openfeature";
import type { AnyProviderEvent, ProviderEventEmitter, ResolutionDetails } from "@openfeature/web-sdk";
import { ProviderEvents, OpenFeatureEventEmitter } from "@openfeature/web-sdk";

export class OverridableOctopusFeatureToggleProvider extends OctopusFeatureProvider {
    private featureToggleOverrides: Readonly<Record<string, boolean>>;

    constructor(configuration: OctopusFeatureConfiguration) {
        super(configuration);
        this.events = new OpenFeatureEventEmitter();
        this.featureToggleOverrides = {};
    }

    updateOverrides(featureToggleOverrides: Readonly<Record<string, boolean>>) {
        this.featureToggleOverrides = featureToggleOverrides;
        this.events?.emit(ProviderEvents.ConfigurationChanged);
    }

    events?: ProviderEventEmitter<AnyProviderEvent> | undefined;

    resolveBooleanEvaluation(flagKey: string, defaultValue: boolean): ResolutionDetails<boolean> {
        const override = Object.entries(this.featureToggleOverrides).find(([name]) => name.toLowerCase() === flagKey.toLowerCase());

        if (override) {
            const [name, value] = override;
            return { value };
        }

        return super.resolveBooleanEvaluation(flagKey, defaultValue);
    }
}
